// extracted by mini-css-extract-plugin
module.exports = {"EventsList":"EventsListBlock_EventsList__36Lcl"};